import React from 'react';

import { useMantineTheme } from '@mantine/core';

interface Props {
    size?: number;
    color?: string;
    dimmed?: boolean;
}

export const CSA = ({ size = 32, color = 'currentColor', dimmed = false }: Props) => {
    const theme = useMantineTheme();

    return (
        <svg
            width={size}
            height={size}
            viewBox="2.069 2.078 67.899 67.844"
            fill={dimmed ? theme.colors.gray[5] : color}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="m65.639 39.234a3.366 3.366 0 1 0 -.002-6.734 3.366 3.366 0 0 0 .002 6.734zm-4.293-3.367a4.293 4.293 0 1 1 8.585.003 4.293 4.293 0 0 1 -8.585-.003m-13.589 9.81a15.181 15.181 0 0 0 3.117-6.382h-5.202l-.013 15.831a21.303 21.303 0 0 1 -6.651 2.053v-42.449c10.465 1.41 18.501 10.377 18.501 21.227a21.332 21.332 0 0 1 -5.087 13.862zm-2.144-12.93h5.276a15.229 15.229 0 0 0 -5.273-8.577zm20.234 1.96h-1.115v.759h1.145c.148-.015.312-.179.312-.401 0-.224-.342-.358-.342-.358zm-1.115 1.8v1.772h-1.073v-4.51l2.813.016s.952.297.996 1.011-.059.789-.149.938c-.087.148-.341.491-.596.61l1.042 1.935h-1.235l-.966-1.772zm-49.364 4.89c2.168 8.282 9.168 14.608 17.806 15.782v-19.704l-10.039-9.649a15.341 15.341 0 0 1 3.649-3.97l-.007 3.561h6.487v-12.695c-8.514 1.122-15.451 7.245-17.766 15.32l11.154 9.992v7.98a15.241 15.241 0 0 1 -5.437-8.345zm20.639-39.319c-18.735 0-33.938 15.171-33.938 33.906 0 18.734 15.203 33.938 33.938 33.938 10.443 0 19.776-4.732 26-12.157l-6.531-5.687c-4.624 5.521-11.549 9.031-19.313 9.031-13.89 0-25.167-11.245-25.219-25.125v-.094c0-13.921 11.298-25.187 25.219-25.187 7.809 0 14.783 3.55 19.406 9.125l6.532-5.531c-6.223-7.474-15.609-12.219-26.094-12.219z" />
        </svg>
    );
};
